import React, { useEffect, useState, useCallback } from 'react';
import './PageLayout.css';
import { API_BASE_URL } from '../services/api';
import axios from 'axios';

function EC3Page() {
    const [epds, setEpds] = useState([]);
    const [filters, setFilters] = useState({ Name: '', Category: '', Location: '' });
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchEPDs = useCallback(async () => {
        setLoading(true);
        try {
            const params = {
                page,
                limit: 100,
              };
              
              if (filters.Name) params.Name = filters.Name;
              if (filters.Category) params.Category = filters.Category;
              if (filters.Location) params.Location = filters.Location;
              
              axios.get(`${API_BASE_URL}/ec3-filtered`, { params })
                .then((res) => {
                  setEpds(res.data.results);
                  setTotal(res.data.total);
                })
                .catch((err) => {
                  console.error("❌ Error fetching filtered EC3 data:", err);
                });
              
    
            const res = await axios.get(`${API_BASE_URL}/ec3-filtered`, { params });
            setEpds(res.data.results);
            setTotal(res.data.total);
        } catch (err) {
            console.error("❌ Error fetching filtered EC3 data:", err);
        } finally {
            setLoading(false);
        }
    }, [filters, page]); // ✅ Declare dependencies here
    
    useEffect(() => {
        fetchEPDs();
    }, [fetchEPDs]); // ✅ React is happy now
    
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleSearch = () => {
        setPage(1);
        fetchEPDs();
    };

    const totalPages = Math.ceil(total / 100);

    return (
        <div className="supply-rates-container">
            <div className="filter-section">
                <h3>Filters</h3>
                <input name="Name" placeholder="Name" value={filters.Name} onChange={handleFilterChange} />
                <input name="Category" placeholder="Category" value={filters.Category} onChange={handleFilterChange} />
                <input name="Location" placeholder="Location" value={filters.Location} onChange={handleFilterChange} />
                <button onClick={handleSearch}>Search</button>
            </div>

            <div className="table-section">
                <h1>EC3 EPD Data</h1>
                {loading ? <p>Loading data...</p> : (
                    <>
                        <p>Showing page {page} of {totalPages} — Total results: {total}</p>
                        <table className="supply-table">
                            <thead>
                                <tr>
                                    <th>EPD ID</th>
                                    <th>Name</th>
                                    <th>Category</th>
                                    <th>GWP</th>
                                    <th>Declared Unit</th>
                                    <th>Mass</th>
                                    <th>Date of Issue</th>
                                    <th>Developer</th>
                                    <th>Location</th>
                                </tr>
                            </thead>
                            <tbody>
                                {epds.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{item.EPDId}</td>
                                        <td>{item.Name}</td>
                                        <td>{item.Category}</td>
                                        <td>{item.GWP}</td>
                                        <td>{item.DeclaredUnit}</td>
                                        <td>{item.MassPerDeclaredUnit}</td>
                                        <td>{item.DateOfIssue}</td>
                                        <td>{item.Developer}</td>
                                        <td>{item.Location}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page === 1}>Prev</button>
                            <span> Page {page} of {totalPages} </span>
                            <button onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default EC3Page;
